import React, { useContext } from "react";

import { DiscountProgressBarContext } from "../context";

import { BreakpointRow } from "./BreakpointRow";
import { MessageRow } from "./MessageRow";
import { RowKeys } from "./types";

interface Row1BuilderProps {
  row: number;
}

export const RowBuilder = ({ row }: Row1BuilderProps) => {
  const { theme, windowState } = useContext(DiscountProgressBarContext);

  for (const rowKey of RowKeys) {
    if (theme[rowKey].row === row && theme[rowKey].enabled) {
      if (rowKey === "message") {
        return <MessageRow message={windowState.message} />;
      }

      if (rowKey === "breakpoint") {
        return <BreakpointRow />;
      }

      if (rowKey === "label") {
        return <MessageRow message={windowState.unlockedMessage} />;
      }
    }
  }
  return null;
};
